import { render, staticRenderFns } from "./TemporalChart.vue?vue&type=template&id=65464be0&"
import script from "./TemporalChart.vue?vue&type=script&lang=ts&"
export * from "./TemporalChart.vue?vue&type=script&lang=ts&"
import style0 from "./TemporalChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports